<template>
  <div>
    <div class="main">
      <p class="infoTop">咨询师会尽快回复你的提问</p>
      <div class="create">
        <div class="name">概述</div>
        <textarea rows="2" v-model="consultTitle"
          class="title" placeholder="请用一句话概述你的问题，10-40字左右（必填）">
          </textarea>
        <div class="name">详情</div>
        <textarea rows="11" v-model="consultContent"
          class="content" placeholder="请填写遇到的生涯困惑情况、问题背景等详细信息（选填）">
          </textarea>
      </div>
      <p class="infoBottom"><span class="star">*</span>个人隐私信息受保护</p>
    </div>
    <div class="bottom">
       <button class="back-button" @click="emitBackConsult">返回咨询首页</button>
       <button class="play-button" @click="handleSubmit" v-preventReClick>提交咨询</button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import axios from 'axios';
import qs from 'qs';
import setWechatTitle from '@/utils/setWechatTitle.js'
import ConsultBox from '@/components/consult/consultBox.vue'
export default {
  name: 'ConsultCreate',
  props: {
  },
  components: {
    ConsultBox,
  },

  data () {
    return {
      consultTitle: '',
      consultContent: '',
		}
  },
  computed: {
    ...mapState({
      shengyaUser: state => state.shengyaUser.userInfo,
    }),
  },
  created(){
    setWechatTitle('在线咨询');
  },
	beforeMount() {
	},
  mounted() {
  },
  updated() {
  },
  beforeDestroy () {
    // console.log('开始 mission beforeDestroy() 关闭监听')
  },
  methods: {
    handleSubmit() {
      const options = {
        method: 'POST',
        headers: {
          'content-type': 'application/x-www-form-urlencoded'
        },
        data: qs.stringify({
          title: this.consultTitle,
          content: this.consultContent,
          openId: this.shengyaUser.openid
        }),
        url: '/cob/saveCosConsult.do'
      };
      axios(options)
      .then( (res) => {
        if(res.data.result.success){
          let consult = res.data.data
          this.$emit('created-consult', consult)
        }else
          this.$store.commit('showMessage', {
            message: res.data.result.message,
            type: 'error'
          })
      })
      .catch(function (error) {
        console.warn(error);
      })
    },
    //咨询
    handleStartConsult() {
      // this.enterDetail = true
    },
    //返回咨询
    emitBackConsult() {
      this.$emit('back-consult')
    },
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.main
  height:90vh
.infoTop
  text-align: right
  margin: 0.14rem 0.3rem 0.14rem 1rem
  // color: #FB8D3E
  font-size: 0.24rem;
.create
  margin: 0 0.24rem
  padding: 0.1rem 0.3rem 0.2rem 0.3rem
  background: #fff;
  border:1px #BBBBBB solid;
  .name
    font-size: 0.28rem
    margin: 0.26rem 0 0.06rem 0
  .title
    font-size: 0.28rem
    border:1px #BBBBBB solid;
    width:100%
    margin: 0.06rem 0
    color:#999
    padding:0.1rem 0
    text-indent:0.2rem
  .content
    font-size: 0.28rem
    border:1px #BBBBBB solid;
    width:100%
    margin: 0.06rem 0
    color:#999
    padding:0.1rem 0
    text-indent:0.2rem

.infoMiddle
  text-align: right
  margin: 0.1rem 0rem
  color: #FB8D3E
  font-size: 0.24rem;
.infoBottom
  text-align: left
  margin: 0.14rem 0.3rem 0.14rem 0.3rem
  font-size: 0.28rem
  .star
    color:#DC6E5A
    font-size:0.5rem

.bottom
    padding: 0.24rem
   .back-button
      width: 42%
      height: 0.84rem
      margin-left: 0.4rem
      background: #787878
      color: #fff
   .play-button
      width: 42%
      height: 0.84rem
      margin-left: 0.4rem
      background: #FB8D3E
      color: #fff

</style>
